import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import { TailSpin } from 'react-loader-spinner';
import Overview from "./Reports/report-pdf/Overview";
import FourQuadrants from "./Reports/report-pdf/FourQuadrants";
import HeartStarterQuadrants from "./Reports/report-pdf/HeartStarterQuadrants";
import AlignmentFlowFirst from "./Reports/report-pdf/AlignmentFlowFirst";
import AlignmentFlowSecond from "./Reports/report-pdf/AlignmentFlowSecond";
import Mindset from "./Reports/report-pdf/Mindset";
import ReflectAndIntegrate1 from "./Reports/report-pdf/ReflectAndIntegrate1";
import ReflectAndIntegrate2 from "./Reports/report-pdf/ReflectAndIntegrate2";
import ReflectAndIntegrate3 from "./Reports/report-pdf/ReflectAndIntegrate3";
import ReflectAndIntegrate4 from "./Reports/report-pdf/ReflectAndIntegrate4";
import Snapshot360 from "./Reports/report360-pdf/Snapshot360";
import SnapshotSecond360 from "./Reports/report360-pdf/SnapshotSecond360";
import StarterQuardrantPreview360 from "./Reports/report360-pdf/StarterQuardrantPreview360";
import YourQuardrantsFlowPreview360 from "./Reports/report360-pdf/YourQuardrantsFlowPreview360";
import HeartToSoulPreview360 from "./Reports/report360-pdf/HeartToSoulPreview360";
import QF_ItemOnePage360 from "./Reports/report360-pdf/QF_ItemOnePage360";
import QF_ItemTwoPage360 from "./Reports/report360-pdf/QF_ItemTwoPage360";
import QF_ItemThirdPage360 from "./Reports/report360-pdf/QF_ItemThirdPage360";
import QF_ItemFourthPage360 from "./Reports/report360-pdf/QF_ItemFourthPage360";
import HeartPreview360 from "./Reports/report360-pdf/HeartPreview360";
import SoulPreview360 from "./Reports/report360-pdf/SoulPreview360";
import MindPreview360 from "./Reports/report360-pdf/MindPreview360";
import StrengthPreview360 from "./Reports/report360-pdf/StrengthPreview360";
import LeadershipStyleFirst360 from "./Reports/report360-pdf/LeadershipStyleFirst360";
import LeadershipStyleSecond360 from "./Reports/report360-pdf/LeadershipStyleSecond360";
import LeadershipStyleThird360 from "./Reports/report360-pdf/LeadershipStyleThird360";
import LeadershipFlowPreview360 from "./Reports/report360-pdf/LeadershipFlowPreview360";
import LeadershipFlowSecondPreview360 from "./Reports/report360-pdf/LeadershipFlowSecondPreview360";
import LeadershipItemFirst360 from "../Report360/LeadershipItemFirst360";
import LeadershipItemSecond360 from "./Reports/report360-pdf/LeadershipItemSecond360";
import LeadershipItemThird360 from "./Reports/report360-pdf/LeadershipItemThird360";
import CollabrativeInFocus360 from "./Reports/report360-pdf/CollabrativeInFocus360";
import VisionaryInFocus360 from "./Reports/report360-pdf/VisionaryInFocus360";
import StrategicInFocus360 from "./Reports/report360-pdf/StrategicInFocus360";
import PerformanceInFocus360 from "./Reports/report360-pdf/PerformanceInFocus360";
import CoverPage from "./Reports/report-pdf/CoverPage";
import TableContentPreview from "./Reports/report-pdf/TableContentPreview";
import HomeStarterQuadrantPreview from "./Reports/report-pdf/HomeStarterQuadrantPreview";
import StarterQuardrant from "./Reports/report-pdf/StarterQuardrant";
import HomeQuadrantFlow from "./Reports/report-pdf/HomeQuadrantFlow";
import HomeLeadershipStyle from "./Reports/report-pdf/HomeLeadershipStyle";
import LeadershipCollabrative from "./Reports/report360-pdf/LeadershipCollabrative";
import HomeMindset from "./Reports/report-pdf/HomeMindset";
import MindsetResult from "./Reports/report-pdf/MindsetResult";
import MindsetResult2 from "./Reports/report-pdf/MindsetResult2";
import HomeReflectAndIntegrate from "./Reports/report-pdf/HomeReflectAndIntegrate";
import StarterQuardrant360 from "./Reports/report360-pdf/StarterQuardrant360";
import HeartStarterQuadrantsResults360 from "./Reports/report360-pdf/HeartStarterQuadrantsResults360";
import LeadershipItemOverview360 from "./Reports/report360-pdf/LeadershipItemOverview360";
import LeadershipSecondItemOverview360 from "./Reports/report360-pdf/LeadershipSecondItemOverview360";
import LeadershipThirdItemOverview360 from "./Reports/report360-pdf/LeadershipThirdItemOverview360";
import LeadershipFourthItemOverview360 from "./Reports/report360-pdf/LeadershipFourthItemOverview360";
import MindsetSecondPage360 from "./Reports/report360-pdf/MindsetSecondPage360";
import AlignmentFlowSecond360 from "./Reports/report360-pdf/AlignmentFlowSecond360";
import AlignmentFlowFirst360 from "./Reports/report360-pdf/AlignmentFlowFirst360";
import GroupReportContext from "../../Context/GroupReportContext";
import QuadrentFlowMeasure from "./Reports/report-pdf/QuadrentFlowMeasure";

const formatDate = (dateStr) => {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  const day = date.getDate();
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${month} ${day}, ${year}`;
};

export default function ReportPreview360({ activeSubMenu, activeMenu, apiData, menuItems, memberResults }) {
  // console.log("activeSubMenu, activeMenu, apiData, menuItems, memberResults", activeSubMenu, activeMenu, apiData, menuItems, memberResults)
  const [localData, setLocalData] = useState(null);
  const [processedMemberData, setProcessedMemberData] = useState(null);
  const sectionRefs = useRef({});
  const [isLoading, setIsLoading] = useState(true)
  const { currentTeamData, averagePercentages, averagePercentagesSelf } = useContext(GroupReportContext)

  // Define the report type for 360 reports
  const reportType = "360 REPORT";

  // Memoize the render360Data to prevent unnecessary re-renders
  const render360Data = useMemo(() => {

    const allMembersData = currentTeamData?.results?.reduce((acc, el) => {
      if (el?.hash) {
        acc[el.hash] = el;
      }
      return acc;
    }, {});

    return {
      ...apiData,
      memberResults: {
        "allMembersData": allMembersData,
        "memberCount": allMembersData?.length
      }
    }
  }, [processedMemberData, apiData, currentTeamData]);

  // Define the report sections for 360 reports
  const reportSections = [
    "Cover Page",
    "Table of Contents",
    "Overview",
    "Summary Snapshot",
    "Summary Snapshot 1",
    "Quadrent Flow Measure",
    "Snapshot Results 360",
    "Starter Quadrant",
    "Four Quadrants",
    "Results 360",
    "HomeQuadrantFlow",
    "Introduction",
    "Quadrant Flow",
    "Items overview 360",
    "QFItemOnePage",
    "QFItemTwoPage",
    "QFItemThirdPage",
    "QFItemFourthPage",
    "Heart In Focus 360",
    "Heart",
    "Soul",
    "Mind",
    "Strength",
    "Home Leadership Style",
    "Leadership Style Introduction",
    "Leadership Style Results",
    "Leadership Style Chart",
    "Leadership Flow Introduction",
    "Leadership Flow Results",
    "Leadership Flow Introduction 360",
    "Items Overview Leadership 360",
    "Item Overview Leadership 1",
    "Item Overview Leadership 2",
    "Item Overview Leadership 3",
    "Item Overview Leadership 4",
    "Leadership Flow In Focus 360",
    "Collaborative",
    "Visionary",
    "Strategic",
    "Performance",
    "Alignment",
    "Alignment 1",
    "Alignment 2",
    "Home Mindset",
    "Mindset Introduction",
    "Mindset Results",
    "Result 1",
    "Result 2",
    "Home Reflect And Integrate",
    "Reflect and Integrate",
    "Life Integration",
    "Leadership Integration",
    "Final Thoughts"
  ];

  // Function to calculate page numbers for 360 report sections
  const getPageNumber = (sectionKey) => {
    const pageMapping = {
      "Cover Page": 1,
      "Table of Contents": 2,
      "Overview": 3,
      "Summary Snapshot": 4,
      "Summary Snapshot 1": 4,
      "Quadrent Flow Measure": 5,

      "Snapshot Results 360": 6,

      "Starter Quadrant": 7,
      "Four Quadrants": 8,
      "Results 360": 9,

      "HomeQuadrantFlow": 10,
      "Introduction": 11,
      "Quadrant Flow": 12,

      "Items overview 360": 13,
      "QFItemOnePage": 13,
      "QFItemTwoPage": 14,
      "QFItemThirdPage": 15,
      "QFItemFourthPage": 16,

      "Heart In Focus 360": 17,
      "Heart": 17,
      "Soul": 18,
      "Mind": 19,
      "Strength": 20,

      "Home Leadership Style": 21,
      "Leadership Style Introduction": 22,
      "Leadership Style Results": 23,
      "Leadership Style Chart": 24,

      "Leadership Flow Introduction": 25,
      "Leadership Flow Results": 25,
      "Leadership Flow Introduction 360": 26,

      "Items Overview Leadership 360": 27,
      "Item Overview Leadership 1": 27,
      "Item Overview Leadership 2": 28,
      "Item Overview Leadership 3": 29,
      "Item Overview Leadership 4": 30,

      "Leadership Flow In Focus 360": 31,
      "Collaborative": 31,
      "Visionary": 32,
      "Strategic": 33,
      "Performance": 34,

      "Alignment": 35,
      "Alignment 1": 35,
      "Alignment 2": 36,

      "Home Mindset": 37,
      "Mindset Introduction": 38,
      "Mindset Results": 39,
      "Result 1": 39,
      "Result 2": 40,

      "Home Reflect And Integrate": 41,
      "Reflect and Integrate": 42,
      "Life Integration": 43,
      "Leadership Integration": 44,
      "Final Thoughts": 45
    };

    return pageMapping[sectionKey] || 1;
  };


  const renderCommonContent = (sectionName, data, pageNumber) => {
    // Use the memoized render360Data for 360 reports
    const dataToUse = render360Data;


    // console.log("dataToUse,reportType,pageNumber",dataToUse,reportType,pageNumber)

    switch (sectionName) {
      case "Cover Page":
        return <CoverPage name={dataToUse?.fullName} apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Table of Contents":
        // Define the TOC sections and their keys as used in the report
        const tocSections = [
          { label: "OVERVIEW", key: "Overview" },
          { label: "SNAPSHOT", key: "Snapshot Results 360" },
          { label: "STARTER QUADRANT", key: "Starter Quadrant" },
          { label: "QUADRANT FLOW", key: "HomeQuadrantFlow" },
          { label: "LEADERSHIP STYLE", key: "Home Leadership Style" },
          { label: "LEADERSHIP FLOW", key: "Leadership Flow Introduction" },
          { label: "GAP ANALYSIS", key: "Alignment" },
          { label: "MINDSET", key: "Home Mindset" },
          { label: "REFLECTIONS", key: "Home Reflect And Integrate" },
        ];
        const tocPageNumbers = tocSections.map(section => getPageNumber(section.key));
        return <TableContentPreview
          menuItems={menuItems}
          reportType={reportType}
          pageNumber={pageNumber}
          tocSections={tocSections}
          tocPageNumbers={tocPageNumbers}
        />;
      case "Overview":
        return <Overview apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Summary Snapshot":
      case "Summary Snapshot 1":
        return <Snapshot360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Quadrent Flow Measure":
        return <QuadrentFlowMeasure apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Snapshot Results 360":
        return <SnapshotSecond360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Starter Quadrant":
        return <HomeStarterQuadrantPreview apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Four Quadrants":
        return <FourQuadrants apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Results 360":
        return <StarterQuardrant360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      //Quardrant Flow
      case "HomeQuadrantFlow":
        return <HomeQuadrantFlow apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Introduction":
        return <YourQuardrantsFlowPreview360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Quadrant Flow":
        return <HeartToSoulPreview360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Items overview 360":
      case "QFItemOnePage":
        return <QF_ItemOnePage360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "QFItemTwoPage":
        return <QF_ItemTwoPage360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "QFItemThirdPage":
        return <QF_ItemThirdPage360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "QFItemFourthPage":
        return <QF_ItemFourthPage360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Heart In Focus 360":
      case "Heart":
        return <HeartPreview360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Soul":
        return <SoulPreview360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Mind":
        return <MindPreview360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Strength":
        return <StrengthPreview360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      // Leadership Style
      case "Home Leadership Style":
        return <HomeLeadershipStyle apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Leadership Style Introduction":
        return <LeadershipStyleSecond360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Leadership Style Results":
        return <LeadershipCollabrative apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
         case "Leadership Style Chart":
        return <LeadershipStyleFirst360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />

      // Leadership Flow 
      case "Leadership Flow Introduction":
      case "Leadership Flow Results":
        return <LeadershipFlowPreview360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Leadership Flow Introduction 360":
        return <LeadershipFlowSecondPreview360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Items Overview Leadership 360":
      case "Item Overview Leadership 1":
        return <LeadershipItemOverview360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Item Overview Leadership 2":
        return <LeadershipSecondItemOverview360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Item Overview Leadership 3":
        return <LeadershipThirdItemOverview360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Item Overview Leadership 4":
        return <LeadershipFourthItemOverview360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Leadership Flow In Focus 360":
      case "Collaborative":
        return <CollabrativeInFocus360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Visionary":
        return <VisionaryInFocus360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Strategic":
        return <StrategicInFocus360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Performance":
        return <PerformanceInFocus360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      //Alignment Flow  
      case "Alignment":
      case "Alignment 1":
        return <AlignmentFlowFirst360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Alignment 2":
        return <AlignmentFlowSecond360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      //Mindset
      case "Home Mindset":
        return <HomeMindset reportType={reportType} pageNumber={pageNumber} />;
      case "Mindset Introduction":
      case "Mindset 1":
        return <Mindset apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      // case "Mindset 2":
      //   return <MindsetSecondPage360 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Mindset Results":
      case "Result 1":
        return <MindsetResult apiData={dataToUse} pageNumber={pageNumber} reportType={reportType} />;
      case "Result 2":
        return <MindsetResult2 apiData={dataToUse} pageNumber={pageNumber} reportType={reportType} />;

      // Reflect and Integrate   
      case "Home Reflect And Integrate":
        return <HomeReflectAndIntegrate apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Reflect and Integrate":
        return <ReflectAndIntegrate1 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Life Integration":
        return <ReflectAndIntegrate2 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Leadership Integration":
        return <ReflectAndIntegrate3 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      case "Final Thoughts":
        return <ReflectAndIntegrate4 apiData={dataToUse} reportType={reportType} pageNumber={pageNumber} />;
      // 360-specific section
      case "Feedback Comparison":
        return <div>Feedback Comparison Content for 360 Report</div>;
      // Group-specific section
      case "Group Dynamics":
        return <div>Group Dynamics Content for Group Report</div>;
      // default:
      //   return <p>Select a section</p>;
    }
  };

  const headerData = useMemo(() => {
    const resolvedRespondent = apiData?.fullName || apiData?.respondentName || currentTeamData?.teamName || "";


    const clientData = localStorage.getItem("clientData");
    const parsedData = JSON.parse(clientData);
    const resolvedCompany =
      apiData?.clientData?.organizationName || apiData?.companyName || apiData?.organizationName || parsedData?.company || "";
    const resolvedDate =
      apiData?.lastAsmtCompletedAt ? formatDate(apiData.lastAsmtCompletedAt) : "";
    const resolvedCompletionDate = currentTeamData?.createdDate ? formatDate(currentTeamData.createdDate) : resolvedDate;
    const resolvedReportName = resolvedRespondent;

    return {
      respondentName: resolvedRespondent,
      companyName: resolvedCompany,
      date: resolvedDate || parsedData?.lastAsmtCompletedAt,
      reportDataName: resolvedReportName,
      completionDate: resolvedCompletionDate,
    };
  }, [
    apiData?.fullName,
    apiData?.respondentName,
    apiData?.clientData?.organizationName,
    apiData?.companyName,
    apiData?.organizationName,
    apiData?.lastAsmtCompletedAt,
    currentTeamData?.teamName,
    currentTeamData?.createdDate,
  ]);

  useEffect(() => {
    const hasValue = Object.values(headerData).some(Boolean);
    if (hasValue) {
      sessionStorage.setItem("selfReportHeaderData", JSON.stringify(headerData));
    }
  }, [headerData]);

  const renderAllSections = () => {
    const data = localData || apiData;
    const currentSection = activeSubMenu || activeMenu;
    const currentPageNumber = getPageNumber(currentSection);
    const renderedPages = new Set();

    return reportSections.map((sectionName, index) => {
      const pageNumber = getPageNumber(sectionName) || index + 1;

      // If this is not the active section, and another section for this page number exists and is active, skip rendering
      if (
        pageNumber === currentPageNumber &&
        sectionName !== currentSection
      ) {
        return null;
      }
      if (renderedPages.has(pageNumber)) {
        return null;
      }
      renderedPages.add(pageNumber);

      const className = sectionName?.toLowerCase().replace(/\s+/g, '-');

      return (
        <div
          key={sectionName}
          className={className}
          ref={(el) => (sectionRefs.current[sectionName] = el)}
          style={{ marginBottom: "40px", background: "#fff", width: "612px", height: "792px", position: 'relative', padding: "36px 72px", boxSizing: "border-box" }}
        >
          {renderCommonContent(sectionName, data, pageNumber)}
        </div>
      );
    });
  };

  useEffect(() => {
    const currentSection = activeSubMenu || activeMenu;
    const el = sectionRefs.current[currentSection];
    if (el && el.scrollIntoView) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [activeMenu, activeSubMenu]);

  useEffect(() => {
    if (apiData && Object.keys(apiData).length > 0) {
      setLocalData(apiData);
    }
  }, [apiData, activeMenu, activeSubMenu]);

  useEffect(() => {
    if (apiData && Object.keys(apiData).length > 0 &&
      averagePercentages && averagePercentagesSelf && currentTeamData) {
      setIsLoading(false)
    } else {
      setIsLoading(true)
    }
  }, [apiData, averagePercentagesSelf, averagePercentages, currentTeamData]);

  return (
    <div>
      {isLoading && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: "#fff",
          position: 'relative',
          marginBottom: "40px", background: "#fff", width: "612px", height: "792px", boxSizing: "border-box"
        }}>
          <TailSpin
            height="60"
            width="60"
            color="#007bff"
            ariaLabel="loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      )}
      {!isLoading && renderAllSections()}
    </div>
  );
}
